module.exports = require('./lib');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-autosize-textarea/index.js
 ** module id = ./node_modules/react-autosize-textarea/index.js
 ** module chunks = 1
 **/